import React from 'react';
import ProductoCuadro from './ProductoCuadro';
import { withRouter } from 'react-router-dom'

const ListadoProducto = props => {
  const { 
    onCharterClick, 
    onProductoClick, 
    idProducto, 
    productos, 
    idCharterDeURL, 
    origen, 
    solosYsolas, 
    pasajerosAdultos,
    destino
  } = props;

  //FC: funciones para ordenar dentro del array de productos encontrados al que la persona busco por su idProducto
  const encontrarIndiceDelProductoSeleccionado = (producto, index, array) => {
    return Number(producto.idProducto) === Number(idProducto);
  }

  const moverElementoDentroDeArray = (arr, old_index, new_index) => {
      while (old_index < 0) {
          old_index += arr.length;
      }
      while (new_index < 0) {
          new_index += arr.length;
      }
      if (new_index >= arr.length) {
          var k = new_index - arr.length;
          while ((k--) + 1) {
              arr.push(undefined);
          }
      }
       arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
     return arr;
  }

  const handleProductoClick = (producto) => {
      onProductoClick(producto);
   }

   const handleCharterClick = (charter) => {
      onCharterClick(charter);
   }

    //FC de los productos traidos, ubico primero el buscado
    if (productos.length > 0 && idProducto) {
      let indiceAnterior = productos.findIndex(encontrarIndiceDelProductoSeleccionado, this);
      if (indiceAnterior >= 0)
        moverElementoDentroDeArray(productos, indiceAnterior, 0);
    }


      return (<div>
                {/*Si elegi un prod en la pantalla anterior muestro primero ese y luego el resto que coincida con la busqueda
                this.state.productoSeleccionado.idProducto && <ProductoCuadro producto={this.state.productoSeleccionado}
                                                                               onCharterClick={this.handleCharterClick}
                                                                               onProductoClick={this.handleProductoClick}  />*/}
                {
                  productos.map((producto) => {
                    return producto.idProducto && (
                      <ProductoCuadro key={ producto.idProducto }
                          producto={producto} origen={origen}
                          onCharterClick={handleCharterClick}
                          onProductoClick={handleProductoClick}
                          idCharterDeURL={idCharterDeURL}
                          solosYsolas={solosYsolas} 
                          pasajerosAdultos={pasajerosAdultos}
                          destino={destino}
                          tarifaPorHabitacion={producto.tarifaPorHabitacion === '1'}
                        />
                      )
                  })
                }
              </div>
            );
}

export default withRouter(ListadoProducto)



// WEBPACK FOOTER //
// ./src/components/Resultados/ListadoProducto/index.js